
import { Vue, Component, Prop } from 'vue-property-decorator';

import ModalFullScreen from '@/components/modal/ModalFullScreen.vue';
import UiButton from '@/components/button/ui-button.vue';

import InfoIcon from '@/components/icons/CancelInfoIcon.vue';

@Component({
	components: {
		ModalFullScreen,
		UiButton,
		InfoIcon,
	},
})
export default class AddSubscription extends Vue {}
